/**
 * Route paths for the my-profile module.
 * Single source of truth — reuse these instead of hard-coding `/my-profile` strings.
 */
export const MY_PROFILE_ROUTES = {
  root: "/my-profile",
} as const;
